module.exports = __webpack_public_path__ + "img/01663e1.png";